import { AudioThumbnail } from '@graphics';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

const MediaitemAudioThumbnail = ({ type }: { type: 'small' | 'large' }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [largeWidth, setLargeWidth] = useState<number>(400);

  useEffect(() => {
    if (type === 'large' && containerRef.current) {
      const updateWidth = () => setLargeWidth(containerRef.current!.offsetWidth);
      updateWidth();

      window.addEventListener('resize', updateWidth);

      return () => window.removeEventListener('resize', updateWidth);
    }
  }, [type, containerRef.current]);

  return (
    <div
      ref={containerRef}
      className={classNames('relative cursor-pointer', type === 'small' ? 'w-fit' : 'w-full')}
    >
      <AudioThumbnail width={type === 'small' ? 300 : largeWidth} />
    </div>
  );
};

export default MediaitemAudioThumbnail;
